import { useState } from "react";

const watchData = [
  {
    title: "Men’s Watches",
    img: "/images/watches/men.jpg",
    best: true,
  },
  {
    title: "Women’s Watches",
    img: "/images/watches/women.jpg",
    best: true,
  },
  {
    title: "Kids Watches",
    img: "/images/watches/kid.jpg",
    best: false,
  },
  {
    title: "Gift Watches",
    img: "/images/watches/gifts.jpg",
    best: false,
  },
];

const WatchCollections = () => {
  const [activeImage, setActiveImage] = useState(null);

  return (
    <section className="section">
      <div className="container">
        <h2>Watch Collections</h2>
        <p className="section-subtitle">
          Stylish and affordable watches for every age.
        </p>

        <div className="grid">
          {watchData.map((item, index) => (
            <div className="card image-card" key={index}>
              {item.best && <span className="badge">Best Seller</span>}

              <img
                src={item.img}
                alt={item.title}
                className="service-image clickable"
                onClick={() => setActiveImage(item.img)}
              />

              <h3>{item.title}</h3>
            </div>
          ))}
        </div>
      </div>

      {activeImage && (
        <div className="lightbox" onClick={() => setActiveImage(null)}>
          <img src={activeImage} alt="Preview" />
          <span className="close">×</span>
        </div>
      )}
    </section>
  );
};

export default WatchCollections;
